const RENDERER_CONFIG = {
	CAMERA: {
		MIN_DISTANCE: 0.25,
		MAX_DISTANCE: 6,
		DISTANCE_TICK: 1,
	},
	TRANSFORM_CONTROLS: {
		ROTATION_SNAP: 5,
		TRANSLATION_SNAP: 0.1,
	},
	SCREENSHOT: {
		WIDTH: 1080,
		HEIGHT: 1920,
	},
	CONTROLS: {
		PAN_SPEED: 0.8,
	},
	INITIAL_DISTANCE: 1,
	DRACO_DECODER_PATH: 'https://www.gstatic.com/draco/versioned/decoders/1.5.9/',
	MOUSE: {
		UNSELECT_DISTANCE: 0.01,
	},
	COLORS: {
		GREEN: 0x087f5b,
		RED: 0xc92a2a,
		CREAM: 0xde9556,
		LIGHT_CREAM: 0xf8f2e7,
		BLACK: 0x141414,
		LIGHT_GRAY: 0xf8f9fa,
	},
	ACCESSORIES: {
		MOUTING_Z_OFFSET: 0.002,
	},
	LED_TAPES: {
		MOUTING_Z_OFFSET: 0.001,
	},
	MEASUREMENT: {
		LAYER: 1,
		OFFSET: 0.03,
		HORIZONTAL_LABEL_ROTATION: 90,
		TOTAL_HEIGHT: {
			ID: 'total_height',
			LABEL_OFFSET: [-0.03, 0, 0],
			LABEL_ROTATION: -90,
		},
	},
} as const;

export default RENDERER_CONFIG;
